import React, { useState, useEffect, useCallback } from 'react';
import {
  Activity, MapPin, Monitor, Smartphone, Tablet, Globe,
    CheckCircle, XCircle, Shield, LogOut, RefreshCw, Trash2, UserRoundCog, UserX
} from 'lucide-react';
import {
  getLoginHistory, clearLoginHistory,
  formatLocation, formatDevice, formatRelative,
    LOGIN_EVENT_TYPES, IMPERSONATION_EVENT_TYPES
} from '../utils/loginTracker';
import { useConfirm } from './ConfirmDialog';

import { profileApi } from '../api/profileApi';


import 'bootstrap/dist/css/bootstrap.min.css';


import { useToast } from '../components/Toast';
/**
 * LoginActivityCard
 * =================
 * Drops into any page. Reads the login history for the given userId from
 * localStorage (or the backend, when wired) and renders it in a clean list.
 *
 * Props:
 *   - userId (required): id of the user whose activity to show
 *   - title (optional): default "Recent Sign-in Activity"
 *   - canClear (optional, default true): show a Clear button
 *   - limit (optional): max entries to display (default: all stored)
 *   - adminView (optional, default false): show fuller device column, no clear button
 */

const getEventIcon = (type) => {
  switch (type) {
    case 'success':      return CheckCircle;
    case 'mfa_required': return Shield;
    case 'mfa_failed':   return XCircle;
    case 'failed':       return XCircle;
    case 'logout':       return LogOut;
      case 'end': return UserX;
    default:             return Activity;
  }
};

const getDeviceIcon = (deviceType) => {
  if (deviceType === 'Mobile') return Smartphone;
  if (deviceType === 'Tablet') return Tablet;
  return Monitor;
};

export const ImpersonationActivityCard = ({
    userId,  
  title = 'Recent Impersonation Activity',
  canClear = true,
  limit,
  adminView = false,
}) => {
    const toast = useToast();
  const [entries, setEntries] = useState([]);
    //const [entries, setEntries] = useState(JSON.parse(eventsData));
  const [refreshing, setRefreshing] = useState(false);
  const confirm = useConfirm();

  const refresh = useCallback(async () => {
    //const all = getLoginHistory(userId);
      //setEntries(limit ? all.slice(0, limit) : all);
      try {
          
          const res = await profileApi.getRecordedImpersonatedUserEvent({ userId: userId });

          if (res.success) {
              setEntries(limit ? res.data.slice(0, limit) : res.data);
          }
          
          


      } catch (err) {
         console.log(err.message || 'Failed to get user event data');
      } finally {
         // setSavingProfile(false);
      }
      
      //setEntries(limit ? JSON.parse(eventsData).slice(0, limit) : JSON.parse(eventsData));
  }, [userId, limit]);

  useEffect(() => { refresh(); }, [refresh]);

  const handleClear = async () => {
    const ok = await confirm({
      title: 'Clear Impersonation activity?',
      message: `All ${entries.length} event${entries.length !== 1 ? 's' : ''} will be removed. This will not affect your account security.`,
      confirmLabel: 'Clear history',
      variant: 'danger',
    });
    if (!ok) return;
      // clearLoginHistory(userId);

      

      const res = await profileApi.deleteRecorderImpersonationUserEvent({ userId: userId });

      if (res.success) {
          toast.success(
              `Impersonation events deleted successfully`,
              { title: 'Impersonation events' }
          );
      }
      else {
          toast.error(
              `Oops! Something went wrong... try again`,
              { title: 'Impersonation events' }
          );
      }



    setEntries([]);
  };

  const handleRefresh = () => {
    setRefreshing(true);
    setTimeout(() => {
      refresh();
      setRefreshing(false);
    }, 300);
  };

  if (!userId) return null;

  return (
    <div className="card">
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: 12, marginBottom: 18, flexWrap: 'wrap',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{
            width: 40, height: 40, borderRadius: 12,
            background: 'linear-gradient(135deg, #0F766E, #0D9488)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <Activity size={20} color="#fff" strokeWidth={2} />
          </div>
          <div>
            <h3 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: '#1A1D21' }}>
              {title}
            </h3>
            <div style={{ fontSize: 13, color: '#6B7280', marginTop: 2 }}>
              {entries.length === 0
                ? 'No activity recorded yet.'
                : `${entries.length} event${entries.length !== 1 ? 's' : ''} · captured for security auditing`}
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 8 }}>
          <button
            onClick={handleRefresh}
            title="Refresh"
            style={iconBtn('#6B7280')}
          >
            <RefreshCw
              size={14}
              strokeWidth={2.5}
              style={{
                transition: 'transform 0.4s',
                transform: refreshing ? 'rotate(180deg)' : 'rotate(0deg)',
              }}
            />
          </button>
          {canClear && !adminView && entries.length > 0 && (
            <button
              onClick={handleClear}
              title="Clear history"
              style={iconBtn('#DC2626')}
            >
              <Trash2 size={14} strokeWidth={2.5} />
            </button>
          )}
        </div>
          </div>

          

      {entries.length === 0 ? (
        <div style={{
          padding: '32px 16px', textAlign: 'center',
          border: '1px dashed #E8ECF0', borderRadius: 12, color: '#9CA3AF',
        }}>
          <Activity size={28} color="#CBD5E1" strokeWidth={1.5} style={{ marginBottom: 8 }} />
          <div style={{ fontSize: 13, fontWeight: 600 }}>No impersonation events recorded</div>
          <div style={{ fontSize: 12, marginTop: 2 }}>
            Events appear here the next time you impersonate.
          </div>
        </div>
      ) : (
        <div style={{
          border: '1px solid #E8ECF0', borderRadius: 12,
          overflow: 'hidden',
                  }}>
                      {entries.length === 0 ? (
                          <div
                              style={{
                                  padding: '32px 16px',
                                  textAlign: 'center',
                                  border: '1px dashed #E8ECF0',
                                  borderRadius: 12,
                                  color: '#9CA3AF',
                              }}
                          >
                              <Activity
                                  size={28}
                                  color="#CBD5E1"
                                  strokeWidth={1.5}
                                  style={{ marginBottom: 8 }}
                              />
                              <div style={{ fontSize: 13, fontWeight: 600 }}>
                                  No sign-in events recorded
                              </div>
                              <div style={{ fontSize: 12, marginTop: 2 }}>
                                  Events appear here the next time you sign in.
                              </div>
                          </div>
                      ) : (
                          <div
                              style={{
                                  border: '1px solid #E8ECF0',
                                  borderRadius: 12,
                                  overflow: 'hidden',
                              }}
                          >
                              {entries.map((e, idx) => {
                                  const meta = IMPERSONATION_EVENT_TYPES[e.type] || {
                                      label: e.type,
                                      color: '#6B7280',
                                  };

                                  const EventIcon = getEventIcon(e.type);
                                  const DeviceIcon = getDeviceIcon(e.deviceType);

                                  const failed =
                                      e.type === 'failed' || e.type === 'mfa_failed';

                                  return (
                                      <div
                                          key={e.id}
                                          style={{
                                              padding: '12px 14px',
                                              borderBottom:
                                                  idx < entries.length - 1
                                                      ? '1px solid #F1F5F9'
                                                      : 'none',
                                              background: failed
                                                  ? 'rgba(239,68,68,0.03)'
                                                  : '#fff',
                                              transition: 'background 0.15s',
                                          }}
                                          onMouseEnter={(el) => {
                                              el.currentTarget.style.background = '#F8FAFB';
                                          }}
                                          onMouseLeave={(el) => {
                                              el.currentTarget.style.background = failed
                                                  ? 'rgba(239,68,68,0.03)'
                                                  : '#fff';
                                          }}
                                      >
                                          <div className="row align-items-center g-3">
                                              
                                              <div className="col-12 col-sm-1 d-flex justify-content-center justify-content-sm-start">
                                                  {/* Status Icon */}
                                                  <div
                                                      style={{
                                                          width: 32,
                                                          height: 32,
                                                          borderRadius: 10,
                                                          background: `${meta.color}14`,
                                                          display: 'flex',
                                                          alignItems: 'center',
                                                          justifyContent: 'center',
                                                      }}
                                                  >
                                                      <EventIcon
                                                          size={15}
                                                          color={meta.color}
                                                          strokeWidth={2.5}
                                                      />
                                                  </div>
                                              </div>

                                              {/* Event Details */}
                                              <div className="col-12 col-sm-5">
                                                  
                                                  <div style={{ minWidth: 0 }}>
                                                      <div
                                                          style={{
                                                              fontSize: 13,
                                                              fontWeight: 700,
                                                              color: '#1A1D21',
                                                          }}
                                                      >
                                                          {meta.label}
                                                      </div>

                                                      <div
                                                          style={{
                                                              fontSize: 12,
                                                              color: '#6B7280',
                                                              marginTop: 2,
                                                          }}
                                                          title={new Date(
                                                              e.timestamp
                                                          ).toLocaleString()}
                                                      >
                                                          {formatRelative(e.timestamp)} ·{' '}
                                                          {new Date(e.timestamp).toLocaleString(
                                                              'en-US',
                                                              {
                                                                  month: 'short',
                                                                  day: 'numeric',
                                                                  hour: 'numeric',
                                                                  minute: '2-digit',
                                                              }
                                                          )}
                                                      </div>
                                                      <div
                                                          style={{
                                                              fontSize: 12,
                                                              color: '#6B7280',
                                                              marginTop: 2,
                                                          }}
                                                          title={new Date(
                                                              e.timestamp
                                                          ).toLocaleString()}
                                                      >
                                                          <div
                                                              style={{
                                                                  fontSize: 13,
                                                                  fontWeight: 700,
                                                                  color: '#1A1D21',
                                                                  marginTop : '3px'
                                                              }}
                                                          >
                                                              User
                                                          </div>
                                                          @{e.ImpersonatedUserName}·{e.ImpersonatedUserEmail}
                                                      </div>
                                                  </div>
                                              </div>

                                              {/* Device / IP Information */}
                                              <div className="col-12 col-sm-6">
                                                  {adminView ? (
                                                      <div className="row g-2">
                                                          <div className="col-12 col-md-6">
                                                              <InfoCell
                                                                  icon={DeviceIcon}
                                                                  primary={formatDevice(e)}
                                                                  secondary={e.deviceType}
                                                              />
                                                          </div>

                                                          <div className="col-12 col-md-6">
                                                              <InfoCell
                                                                  icon={e.ip ? MapPin : Globe}
                                                                  primary={e.ip || 'IP unknown'}
                                                                  secondary={formatLocation(e)}
                                                                  mono
                                                              />
                                                          </div>
                                                      </div>
                                                  ) : (
                                                      <div
                                                          className="d-flex flex-column align-items-start align-items-sm-end"
                                                          style={{ gap: 2 }}
                                                      >
                                                          <div
                                                              style={{
                                                                  fontSize: 12,
                                                                  color: '#1A1D21',
                                                                  fontWeight: 600,
                                                                  display: 'flex',
                                                                  alignItems: 'center',
                                                                  gap: 5,
                                                                  flexWrap: 'wrap',
                                                              }}
                                                          >
                                                              <DeviceIcon
                                                                  size={11}
                                                                  strokeWidth={2}
                                                                  color="#6B7280"
                                                              />
                                                              {e.browser}
                                                              <span style={{ color: '#9CA3AF' }}>
                                                                  ·
                                                              </span>
                                                              {e.os}
                                                          </div>

                                                          <div
                                                              style={{
                                                                  fontSize: 11,
                                                                  color: '#6B7280',
                                                                  display: 'flex',
                                                                  alignItems: 'center',
                                                                  gap: 5,
                                                                  flexWrap: 'wrap',
                                                              }}
                                                          >
                                                              <MapPin
                                                                  size={10}
                                                                  strokeWidth={2}
                                                                  color="#9CA3AF"
                                                              />
                                                              <span
                                                                  style={{
                                                                      fontFamily: 'monospace',
                                                                  }}
                                                              >
                                                                  {e.ip || '—'}
                                                              </span>

                                                              {e.country && (
                                                                  <span>
                                                                      · {formatLocation(e)}
                                                                  </span>
                                                              )}
                                                          </div>
                                                      </div>
                                                  )}
                                              </div>
                                          </div>
                                      </div>
                                  );
                              })}
                          </div>
                      )}
          {/*{entries.map((e, idx) => {*/}
          {/*  const meta = LOGIN_EVENT_TYPES[e.type] || { label: e.type, color: '#6B7280' };*/}
          {/*  const EventIcon = getEventIcon(e.type);*/}
          {/*  const DeviceIcon = getDeviceIcon(e.deviceType);*/}
          {/*  const failed = e.type === 'failed' || e.type === 'mfa_failed';*/}
          {/*  return (*/}
          {/*    <div*/}
          {/*      key={e.id}*/}
          {/*      style={{*/}
          {/*        display: 'grid',*/}
          {/*        gridTemplateColumns: adminView ? '34px 1fr 1fr 1fr auto' : '34px 1fr auto',*/}
          {/*        gap: 14, alignItems: 'center',*/}
          {/*        padding: '12px 14px',*/}
          {/*        borderBottom: idx < entries.length - 1 ? '1px solid #F1F5F9' : 'none',*/}
          {/*        background: failed ? 'rgba(239,68,68,0.03)' : '#fff',*/}
          {/*        transition: 'background 0.15s',*/}
          {/*      }}*/}
          {/*      onMouseEnter={(el) => { el.currentTarget.style.background = '#F8FAFB'; }}*/}
          {/*      onMouseLeave={(el) => {*/}
          {/*        el.currentTarget.style.background = failed ? 'rgba(239,68,68,0.03)' : '#fff';*/}
          {/*      }}*/}
          {/*    >*/}
                
                    

          {/*          <div className="row">*/}
          {/*              <div className="col-sm-2">*/}

          {/*                  */}{/* Status icon */}
          {/*                  <div style={{*/}
          {/*                      width: 32, height: 32,*/}
          {/*                      borderRadius: 10,*/}
          {/*                      background: `${meta.color}14`,*/}
          {/*                      display: 'flex', alignItems: 'center', justifyContent: 'center',*/}
          {/*                      flexShrink: 0,*/}
          {/*                  }}>*/}
          {/*                      <EventIcon size={15} color={meta.color} strokeWidth={2.5} />*/}
          {/*                  </div>*/}
          {/*              </div>*/}
          {/*              <div className='col-sm-5'>*/}

                            
          {/*                  */}{/* When + what */}
          {/*                  <div style={{ minWidth: 0 }}>*/}
          {/*                      <div style={{ fontSize: 13, fontWeight: 700, color: '#1A1D21' }}>*/}
          {/*                          {meta.label}*/}
          {/*                      </div>*/}
          {/*                      <div*/}
          {/*                          style={{ fontSize: 12, color: '#6B7280', marginTop: 2 }}*/}
          {/*                          title={new Date(e.timestamp).toLocaleString()}*/}
          {/*                      >*/}
          {/*                          {formatRelative(e.timestamp)} ·{' '}*/}
          {/*                          {new Date(e.timestamp).toLocaleString('en-US', {*/}
          {/*                              month: 'short', day: 'numeric',*/}
          {/*                              hour: 'numeric', minute: '2-digit',*/}
          {/*                          })}*/}
          {/*                      </div>*/}
          {/*                  </div>*/}
          {/*              </div>*/}
          {/*              <div className='col-sm-5'>*/}


          {/*                  */}{/* Admin-only columns: device + location split out */}
          {/*                  {adminView && (*/}
          {/*                      <>*/}
          {/*                          <InfoCell icon={DeviceIcon} primary={formatDevice(e)} secondary={e.deviceType} />*/}
          {/*                          <InfoCell*/}
          {/*                              icon={e.ip ? MapPin : Globe}*/}
          {/*                              primary={e.ip || 'IP unknown'}*/}
          {/*                              secondary={formatLocation(e)}*/}
          {/*                              mono*/}
          {/*                          />*/}
          {/*                      </>*/}
          {/*                  )}*/}

          {/*                  */}{/* Non-admin: compact IP + device on the right */}
          {/*                  {!adminView && (*/}
          {/*                      <div style={{*/}
          {/*                          display: 'flex', flexDirection: 'column',*/}
          {/*                          alignItems: 'flex-end', gap: 2, flexShrink: 0,*/}
          {/*                      }}>*/}
          {/*                          <div style={{*/}
          {/*                              fontSize: 12, color: '#1A1D21', fontWeight: 600,*/}
          {/*                              display: 'flex', alignItems: 'center', gap: 5,*/}
          {/*                          }}>*/}
          {/*                              <DeviceIcon size={11} strokeWidth={2} color="#6B7280" />*/}
          {/*                              {e.browser}*/}
          {/*                              <span style={{ color: '#9CA3AF' }}>·</span>*/}
          {/*                              {e.os}*/}
          {/*                          </div>*/}
          {/*                          <div style={{ fontSize: 11, color: '#6B7280', display: 'flex', alignItems: 'center', gap: 5 }}>*/}
          {/*                              <MapPin size={10} strokeWidth={2} color="#9CA3AF" />*/}
          {/*                              <span style={{ fontFamily: 'monospace' }}>{e.ip || '—'}</span>*/}
          {/*                              {e.country && <span>· {formatLocation(e)}</span>}*/}
          {/*                          </div>*/}
          {/*                      </div>*/}
          {/*                  )}*/}

          {/*                  */}{/* Admin tail: empty spacer to balance grid */}
          {/*                  {adminView && <div style={{ width: 0 }} />}*/}
          {/*              </div>*/}
          {/*          </div>*/}
                
          {/*    </div>*/}
          {/*  );*/}
          {/*})}*/}
        </div>
      )}

      {/* Privacy / HIPAA disclaimer */}
      <div style={{
        marginTop: 14, fontSize: 11, color: '#9CA3AF',
        lineHeight: 1.5, fontStyle: 'italic',
      }}>
        Impersonate events include IP address, coarse location, and device information,
        captured for security auditing. Entries older than 90 days are automatically removed.
      </div>
    </div>
  );
};

const InfoCell = ({ icon: Icon, primary, secondary, mono = false }) => (
  <div style={{ minWidth: 0 }}>
    <div style={{
      fontSize: 12, fontWeight: 600, color: '#1A1D21',
      display: 'flex', alignItems: 'center', gap: 6,
      fontFamily: mono ? 'monospace' : 'inherit',
      overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
    }}>
      <Icon size={12} strokeWidth={2} color="#9CA3AF" />
      {primary || '—'}
    </div>
    {secondary && (
      <div style={{ fontSize: 11, color: '#6B7280', marginTop: 2 }}>
        {secondary}
      </div>
    )}
  </div>
);

const iconBtn = (color) => ({
  width: 30, height: 30, borderRadius: 8,
  border: `1px solid ${color}33`,
  background: `${color}0A`,
  color,
  cursor: 'pointer',
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
  padding: 0,
  fontFamily: 'inherit',
});

export default ImpersonationActivityCard;
